import React from 'react'
import githubIcon from '../images/github.png'
import linkedinIcon from '../images/linkedin.png'
import SocialIcon from './SocialIcon.js'

class Hero extends React.Component {
    render() {
        return <div id="hero">
            <h1>
                Sashank Gogula Portfolio
            </h1>
            <div id="blurb">
                Fifth-year Master student in Language Technologies at Carnegie Mellon University with interests in natural language processing, human-computer interaction, education, and design.
            </div>
            <div id="links">
                <a href="https://github.com/sashankg" target="_blank">
                    <SocialIcon src={ githubIcon } alt="Github" />
                </a>
                <a href="https://www.linkedin.com/in/sashankgogula/" target="_blank">
                    <SocialIcon src={ linkedinIcon } alt="LinkedIn" />
                </a>
            </div>
        </div>
    }
}

export default Hero  
